import { t } from '@hefe/i18n';
import axios from 'axios';
import { Buffer } from 'buffer';
import { useEffect, useState } from 'react';

export const useHtmlWithAuthImages = (text: string, maxImageWidth?: number) => {
  const [data, setData] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<unknown>(null);

  useEffect(() => {
    const fetchData = async () => {
      if (!text) {
        return;
      }

      const textWithoutImages = text.replace(
        /<img.*?>/g,
        t('knowledge_base.articles.detail_page.loading_image')
      );
      setData(textWithoutImages);

      try {
        setLoading(true);

        const imgSrcRegex = /<img.*?src=['"](.*?)['"]/;
        const imgSrcs = text.match(imgSrcRegex);

        let newText = text;

        if (imgSrcs && imgSrcs.length > 0) {
          const promises = imgSrcs.map(async (imgSrc) => {
            const imgSrcMatch = imgSrcRegex.exec(imgSrc);
            const imgUrl = imgSrcMatch && imgSrcMatch[1];

            if (imgUrl) {
              const response = await axios.get(imgUrl, {
                responseType: 'arraybuffer',
              });

              const base64Image = Buffer.from(response.data, 'binary').toString(
                'base64'
              );

              const imgSrcWithoutImgTag = imgSrc.replace(/<img.*?src=/, '');

              newText = newText.replace(
                imgSrcWithoutImgTag,
                `data:image/jpeg;base64,${base64Image}`
              );

              const maxWidth = `${maxImageWidth}px` || '50%';
              // Put all images as thumbnails to avoid large images. User can click on them to see the full size.
              newText = newText.replace(
                /<img/g,
                '<img style="max-width: ' + maxWidth + ';"'
              );
            }
          });

          await Promise.all(promises);
        }

        setData(newText);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [text]);

  return { data, loading, error };
};

export async function useHtmlWithAuthImages2(text: string) {
  const [loading, setLoading] = useState(false);

  const imgSrcRegex = /<img.*?src=['"](.*?)['"]/g;
  const imgSrcs = text.match(imgSrcRegex);

  if (!imgSrcs) {
    return { text, isLoading: false };
  }

  setLoading(true);

  const promises = imgSrcs.map(async (imgSrc) => {
    const imgUrl = imgSrc.match(/src=['"](.*?)['"]/)?.[1];
    if (imgUrl) {
      const response = await axios.get(imgUrl, { responseType: 'arraybuffer' });
      const base64Image = Buffer.from(response.data, 'binary').toString(
        'base64'
      );
      text = text.replace(
        imgSrc,
        `src="data:image/jpeg;base64,${base64Image}"`
      );
    }
  });

  await Promise.all(promises);
  setLoading(false);

  return { text, isLoading: loading };
}
